import { createContext } from 'react';
import { PersonContextType } from '../types';

export const PersonContext = createContext<PersonContextType | undefined>(
	undefined,
);
